import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import queryString from 'query-string';
import { useStyletron } from 'baseui';
import _map from 'lodash/map';
import _values from 'lodash/values';
import _isEmpty from 'lodash/isEmpty';

import { EMPTY_STRING } from 'commons-ui';
import { USER_PAYMENTS_STATUS_RESOURCES, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import PaymentStatusHome from './PaymentStatusHome';
import { URL, COMPONENT } from './helper';
import usePaymentStatus from './usePaymentStatus';

const PaymentStatus: React.FC<{}> = () => {
	const [css] = useStyletron();
	const { queryParams, userSearchDetails } = usePaymentStatus();

	if (_isEmpty(queryParams)) {
		if (!_isEmpty(userSearchDetails)) {
			const { selectionType, selectedValue } = userSearchDetails;
			const searchString = `?${queryString.stringify({ [selectionType || EMPTY_STRING]: selectedValue })}`;
			return <Redirect to={`/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.paymentsStatus}${searchString}`} />;
		}
		return <Redirect to={`/${PAGE_NAMES.userProfile}/selectUser`} />;
	}

	const redirectUrl = () => {
		return <Redirect to={`/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.paymentsStatus}/home${queryParams}`} />;
	};

	return (
		<>
			<div className={css({ height: '100%', overflow: 'auto' })}>
				<Switch>
					<AuthorizedRouteV2
						exact
						configPageName={PAGE_NAMES.paymentsStatus}
						path={`/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.paymentsStatus}/home`}
						component={PaymentStatusHome}
					/>
					{_map(_values(USER_PAYMENTS_STATUS_RESOURCES), (resourceName: string) => {
						return (
							<AuthorizedRouteV2
								key={resourceName}
								configPageName={PAGE_NAMES.paymentsStatus}
								configResourceName={resourceName}
								path={URL[resourceName]}
								component={COMPONENT[resourceName]}
							/>
						);
					})}
					{redirectUrl()}
				</Switch>
			</div>
		</>
	);
};

export default PaymentStatus;
